import { CopyProperties } from '../decorator/copy-properties.decorator';
import { Constant } from '../constant';
@CopyProperties()
export class UserProfile {
    public id: number;
    public code: string;
    public name: string;
    public shortName: string;
    public avatar: string;
    public address: string;
    public email: string;
    public userType: string;
    public issuerType: any;
    public status: string;
    public passport: string;
    public country: any;
    public countryId: string;
    public idType: any;
    public idTypeId: string;
    public province: any;
    public provinceId: string;
    public balance: string;
    public gender: number;
    public occupationId: number;
    public occupation: any;
    public avatarUrl: string;
    public passportDateOfIssue: string;
    public passportDateOfIssueModel: any;
    public passportPlaceOfIssue: any;
    public businessCode: string;
    public phone: string;
    public birthDateModel: any;
    public birthDate: any;
    public phonePostal: string;
    public phoneCountryCode: string;
    public profilePicture: string;
    public website: string;
    public aboutUs: string;
    public documents: any[];
    constructor(
        params?: any
    ) {
        this.id = undefined;
        this.code = '';
        this.name = '';
        this.shortName = '';
        this.address = '';
        this.email = '';
        this.userType = '';
        this.idTypeId = '';
        this.issuerType = '';
        this.documents = [];
        this.passport = '';
        this.idType = null;
        this.occupation = null;
        this.status = '';
        this.aboutUs =  '';
        this.avatar  = '';
        this.country = null;
        this.province = null;;
        this.balance = '';
        this.gender = null;
        this.birthDate = '';
        this.passportDateOfIssue = '';
        this.passportDateOfIssueModel = null;;
        this.passportPlaceOfIssue = '';
        this.businessCode = '';
        this.phone = '';
        this.phonePostal = '';
        this.phoneCountryCode = '';
        this.profilePicture = '';
        this.website = '';
    }
}